<template>
    <div class="bg-white" style="padding-bottom: 1rem;padding-top: 1rem;">
      <div v-if="tableData.length === 0 && sum === 0" style="text-align: center;">
        <img src="~@/assets/img/list_empty.png" style="padding-top: 50px;" />
        <p style="font-size: 16px; padding: 15px; color: #303133;">{{ $t('Publish.ProductList.Components.MTList.ListItem') }}</p>
        <p style="font-size: 14px; padding: 0 0 30px; color: #909399;">{{ $t('Publish.ProductList.Components.MTList.ListItem1') }}</p>
        <el-button type="primary" style="width: 90%;" @click="jumpProductList">{{ $t('Publish.ProductList.Components.MTList.ChooseProduct') }}</el-button>
        <router-link to="/personal-center/store-manage"><el-button style="width: 90%; margin: 20px 0 0;">{{ $t('Publish.ProductList.Components.MTList.NewStore') }}</el-button></router-link>
      </div>
      <div v-else>
        <div class="f--c topSelect">
          <MTselect :value="searchParams.platformCode" :columns="platformOptions" style="margin-right: 0.5rem;margin-left: .2rem;" @change="platformChange"></MTselect>
          <MTselect :value="searchParams.listingStatus" :columns="statusSelectList" @change="statusChange"></MTselect>
        </div>
        <div style="padding-left: 0.2rem;">
          <vant-checkbox v-model="isAllSelect" @click="checkChangeAll">{{ $t('Publish.Listings.Components.MTList.SelectAll') }}</vant-checkbox>
        </div>
        <div style="padding: 0.2rem;" class="product_group">
          <div v-for="item in tableData" :key="item.id" class="product">
            <div class="failReason" v-if="item.synResult">
              {{ item.synResult}}
            </div>
            <div class="f">
              <vant-checkbox v-model="item.isChecked" class="checkbox" @change="v => checkChange(v, item)"></vant-checkbox>
              <div class="f product_info" @click="visitDetail(item)">
                <el-image :src="item.imageUrl" style="width: 1.6rem;height: 1.6rem;" class="image"></el-image>
                <div class="fontInfo">
                  <p class="ellipsis title">{{ item.title }}</p>
                  <p class="gray">{{ $t('Publish.Listings.Components.MTList.ProductId') }}: {{ item.productId }}</p>
                  <p class="gray">{{ $t('Publish.Listings.Components.MTList.ProductCoat') }}: {{ item.currency }} {{ item.priceScope.split('～')[1] }}</p>
                  <p class="gray">{{ $t('Publish.Listings.Components.MTList.Inventory') }}: {{ item.inventoryQuantityScope.split('～')[1] }}</p>
                </div>
              </div>
            </div>
            <el-divider style="margin: .2rem 0 !important;"></el-divider>
          </div>
        </div>
        <div v-if="searchParams.listingStatus !== 3" class="bottomBtn f-a">
          <el-button style="width: 3rem;" @click="deleteHandle">{{ $t('Publish.Listings.Components.MTList.Delete') }}</el-button>
          <el-button type="primary" style="width: 3rem;" @click="hiddenHandle">{{ $t('Publish.Listings.Components.MTList.Hidden') }}</el-button>
        </div>
      </div>
    </div>
</template>

<script>
import API from '@/api'
import Checkbox from 'vant/lib/checkbox'
import 'vant/lib/checkbox/style'
import MTselect from '@/components/mobile/Select.vue'
import Dialog from 'vant/lib/dialog'
import 'vant/lib/dialog/style'
export default {
  data() {
    return {
      isAllSelect: false,
      total: 0,
      sum: 0,
      searchParams: {
        platformCode: 'SP',
        pageNumber: 1,
        pageSize: 20,
        listingStatus: 1
      },
      statusSelectList: [
        { label: `${this.$t('Publish.Listings.Components.MTList.Published')}`, value: 1 },
        { label: `${this.$t('Publish.Listings.Components.MTList.Hidden')}`, value: 2 },
        { label: `${this.$t('Publish.Listings.Components.MTList.Deleted')}`, value: 3 },
        { label: `${this.$t('Publish.Listings.Components.MTList.ListingQueue')}`, value: 4 }
      ],
      tableData: [],
      popupType: 'delete',
      popupShow: false
    }
  },
  computed: {
    platformOptions() {
      let arr = []
      if (!this.$store.state.common.platformOptions.length) {
        this.$store.dispatch('common/getPlatformOptions')
      } else {
        arr = this.$store.state.common.platformOptions.filter(e => e.platformCode !== 'KA').map(e => ({ label: e.platformName, value: e.platformCode }))
      }
      return arr
    },
    selections() {
      let arr = []
      arr = new Set(this.tableData.filter(e => e.isChecked).map(e => e.id))
      return arr
    }
  },
  components: {
    'vant-checkbox': Checkbox,
    MTselect
  },
  created() {
    this.getList()
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('scroll', this.scrollEvent)
    })
  },
  destroyed() {
    window.removeEventListener('scroll', this.scrollEvent)
  },
  methods: {
    async getList() {
      let res
      const params = Object.assign({}, this.searchParams)
      const loading = this.$loading.service()
      try {
        if (['DJ'].includes(this.searchParams.platformCode)) {
          res = await API.shoplazzaGetListings(params)
        } else if (['KA', 'SP'].includes(this.searchParams.platformCode)) {
          res = await API.publishGetListings(params)
        } else if (['SL'].includes(this.searchParams.platformCode)) {
          res = await API.shoplineGetListings(params)
        }
        let newData = res.data[this.searchParams.listingStatus]
        this.tableData = this.tableData.concat(newData)
        this.total = res.data.count[this.searchParams.listingStatus]

        Object.values(res.data.count).forEach((v, k) => {
          this.sum += v
        })

        loading.close()
      } catch (error) {
        loading.close()
        let message = error.message || error.data.message
        this.$message.error(message)
      }
    },
    checkChangeAll(e) {
      this.tableData.forEach(e => (this.$set(e, 'isChecked', this.isAllSelect)))
    },
    checkChange(v, item) {
      this.isAllSelect = this.tableData.every(e => e.isChecked === true)
    },
    scrollEvent(e) {
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      let windowHeight = document.documentElement.clientHeight || document.body.clientHeight
      let scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight
      let isBottom = scrollTop + windowHeight - scrollHeight > -1
      if (!isBottom) return
      if (this.tableData.length < this.total) {
        this.searchParams.pageNumber++
        this.getList()
      }
    },
    resetPage() {
      this.tableData = []
      this.searchParams.pageNumber = 1
      this.getList()
    },
    // 批量上架&上架&批量下架&下架   type   1上架2下架
    async batchRelistHidden(ids, type) {
      const params = { data: { ids, type }}
      let res
      try {
        if (this.searchParams.platformCode === 'DJ') {
          res = await API.shoplazzaListingStatus(params)
        } else if (['KA', 'SP'].includes(this.searchParams.platformCode)) {
          res = await API.publishListingStatus(params)
        } else if (this.searchParams.platformCode === 'SL') {
          res = await API.shoplineListingStatus(params)
        } else if (this.searchParams.platformCode === 'TT') {
          res = await API.tiktokListingStatus(params)
        }
        this.$message.success(res.message)
        this.tableData = this.tableData.filter(e => !ids.includes(e.id))
      } catch (err) {
        let message = err.message || err.data.message
        this.$message.error(message)
      }
    },
    // 删除  批量删除
    async publishListingDelete(ids, listingStatus) {
      const params = { data: { ids, listingStatus }}
      let res
      try {
        if (this.searchParams.platformCode === 'DJ') {
          res = await API.shoplazzaListingDelete(params)
        } else if (['KA', 'SP'].includes(this.searchParams.platformCode)) {
          res = await API.publishListingDelete(params)
        } else if (this.searchParams.platformCode === 'SL') {
          res = await API.shoplineListingDelete(params)
        } else if (this.searchParams.platformCode === 'TT') {
          res = await API.tiktokListingDelete(params)
        }
        this.$message.success(res.message)
        this.tableData = this.tableData.filter(e => !ids.includes(e.id))
      } catch (err) {
        let message = err.message || err.data.message
        this.$message.error(message)
      }
    },
    deleteHandle() {
      const that = this
      Dialog.confirm({
        message: 'Are you sure you want to delete the product from your store?',
        confirmButtonText: 'confirm',
        cancelButtonText: 'cancel'
      })
        .then(() => {
          // on confirm
          let selections = Array.from(that.selections)
          that.publishListingDelete(selections, that.searchParams.listingStatus)
        })
        .catch(() => {
          // on cancel
        })
    },
    hiddenHandle() {
      const that = this
      Dialog.confirm({
        message: 'Are you sure to Off Shelf these products from store?',
        confirmButtonText: 'confirm',
        cancelButtonText: 'cancel'
      })
        .then(() => {
          // on confirm
          let selections = Array.from(that.selections)
          that.batchRelistHidden(selections, 2)
        })
        .catch(() => {
          // on cancel
        })
    },
    statusChange(value, item) {
      this.searchParams.listingStatus = value
      this.resetPage()
    },
    platformChange(value, item) {
      this.searchParams.platformCode = value
      this.resetPage()
    },
    visitDetail(item) {
      this.$store.commit('published/set', { MTProductDetail: item })
      this.$router.push({
        path: '/publish/MTDetail',
        query: {
          id: item.id
        }
      })
    },
    jumpProductList() {
      location.href = '/product-list'
    }
  }
}
</script>
<style lang="scss" scoped>
.topSelect {
  position: fixed;
  left: 0;
  right: 0;
  top: .8rem;
  background-color: #fff;
  height: .8rem;
  z-index: 1000;
}
.product_group {
  .product {
  width: 100%;
  position: relative;
  .checkbox {
    margin-right: 0.2rem;
    flex-shrink: 0;
  }
  .product_info {
    width: calc(100% - .4rem);
    .image {
      flex-shrink: 0;
      width: 1.6rem;
      height: 1.6rem;
      margin-right: .2rem;
    }
    .fontInfo {
      max-width: calc(100% - 2rem);
      .title {
        font-size: .3rem;
        line-height: .6rem;
      }
      .gray{
        color: #7B7B7B;
      }
    }
    .price {
      font-size: .4rem;
      font-weight: 600;
      display: flex;
      align-items: flex-end;
    }
  }
  .failReason {
    // height: 1rem;
    background-color: #DEDEDE42;
    margin: .1rem 0;
    padding: .1rem .2rem;
  }
  /deep/.el-divider--horizontal {
    margin: .4rem 0 .2rem;
  }
}
}

.bottomBtn {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  box-shadow: 0 -.1rem .1rem #dcdfe6;
  background-color: #fff;
  height: 1.2rem;
  align-items: center;
  >.el-button {
    height: .8rem;
  }
}
</style>
